"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
function default_1({ token, setCompanyInfo, confirm, onLeaderDisagreeError, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const roomId = (0, functions_1.getNumberFromUrl)(window.location.href);
        const errorConfirm = (description) => (0, errors_1.alertConfirm)({ confirm, description });
        yield (0, api_1.postData)(`/api/v1/room/${roomId}/company-info`, { token })
            .then(res => setCompanyInfo(res.data.result))
            .catch(error => {
            var _a, _b, _c, _d, _e, _f;
            const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            if (errorStatus === 400) {
                const errorMsg = (_f = (_e = error.response.data) === null || _e === void 0 ? void 0 : _e.result) === null || _f === void 0 ? void 0 : _f.error_msg;
                switch (errorMsg) {
                    case 'INVALID_RECAPCHA_ERROR':
                        errorConfirm(i18next_1.default.t('구글 캡챠 이슈로 사업자 정보를 불러오지 못했어요. 다시 시도해 주세요!'));
                        break;
                    case 'LEADER_DISAGREE_COMPANY_INFO_ERROR':
                        errorConfirm(i18next_1.default.t('작가님 요청으로 사업자 정보 폐기되었어요'));
                        onLeaderDisagreeError();
                        break;
                }
            }
            else if (errorStatus === 403)
                (0, errors_1.handleForbiddenError)(error);
            else
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode });
        });
    });
}
exports.default = default_1;
